import { useFormik } from 'formik';
import { useEffect } from 'react';
import { FunctionariesSwitch } from '../../../../../../shared/types/systemConfiguration/functionariesSwitch';

export const useFunctionariesSwitchRegisterHistory = (
    functionariesSwitch?: FunctionariesSwitch
) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = functionariesSwitch || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [functionariesSwitch]);

    return { formik };
};
